import { render, staticRenderFns } from "./IssueManageMetadata.vue?vue&type=template&id=4c1042b7&"
import script from "./IssueManageMetadata.vue?vue&type=script&lang=ts&"
export * from "./IssueManageMetadata.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports